import React from "react";
import { Resizable } from "re-resizable";
import "./SnResizable.css";

interface SnResizableProps {
  direction: "height" | "width";
  seq: number;
  cd_menu: string;
  defaultSize: { [key: string]: string | number };
  size: string | number;
  onResizeStop: (seq: number, newSize: number) => void;
  minWidth?: number;
  minHeight?: number;
  enable?: { [key: string]: boolean };
  /**
   * 높이를 고정하지 않고 자식 폼 내용만큼 늘린다 → 폼 안쪽에 스크롤이 생기지 않는다.
   * (넘치는 만큼은 화면의 바깥 스크롤 컨테이너가 담당한다.)
   * 안 넘기면 기존 동작 그대로 — size 로 높이를 고정하고 폼은 자체 스크롤을 갖는다.
   * 크기 조절은 의미가 없어지므로 이 모드에서는 리사이즈 핸들도 만들지 않는다.
   */
  fitContent?: boolean;
  children?: React.ReactNode;
}

export function SnResizable({
  direction,
  seq,
  cd_menu,
  defaultSize,
  size,
  onResizeStop,
  minWidth,
  minHeight,
  enable,
  fitContent,
  children,
}: SnResizableProps) {
  const panelKey = Object.keys(defaultSize)[seq - 1];

  const handleResizeStop = (
    event: MouseEvent | TouchEvent,
    dir: string,
    ref: HTMLElement,
    delta: { width: number; height: number }
  ) => {
    const newSize = direction === "height" ? ref.offsetHeight : ref.offsetWidth;

    let newMenuSize = {};
    const menuSize = localStorage.getItem("menuSize");
    if (menuSize) {
      const parsed = JSON.parse(menuSize);

      // cd_menu에 해당하는 객체가 없다면 일단 default로 추가
      if (!parsed[cd_menu]) parsed[cd_menu] = { ...defaultSize };
      parsed[cd_menu][panelKey] = newSize;
      newMenuSize = { ...parsed };
    } else {
      newMenuSize = {
        [cd_menu]: {
          ...defaultSize,
          [panelKey]: newSize,
        },
      };
    }

    localStorage.setItem("menuSize", JSON.stringify(newMenuSize));
    onResizeStop(seq, newSize);
  };

  if (fitContent) {
    return (
      <div className="sn-resizable-fit">
        {children}
      </div>
    );
  }

  return (
    <Resizable
      size={direction === "height" ? { height: size } : { width: size }}
      minWidth={minWidth}
      minHeight={minHeight}
      onResizeStop={handleResizeStop}
      enable={enable}
    >
      {children}
    </Resizable>
  );
}

export default React.memo(SnResizable);
